const getBaseDomain = hostname => {
  // Check if the hostname is localhost or similar (could also check for 127.0.0.1)
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'localhost';
  }

  // For other domains, just return the base domain (excluding subdomains)
  const domainParts = hostname.split('.');
  const length = domainParts.length;

  if (length >= 2) {
    return domainParts.slice(-2).join('.'); // For example: "example.com"
  }

  return hostname; // Return the hostname as is if it's something else (e.g., an IP address)
};

export default getBaseDomain;
